import Slide from "./slide";
import { $html, $each, $if } from "ekma";

export default (slide: Slide) => $html`
	<div class="container">
		${ $if(slide.state.heading !== "", () => $html`
		<h1 class="heading">$${slide.state.heading}</h1>
		`) }

		${ $if(slide.state.subheading !== "", () => $html`
		<h2 class="subheading">$${slide.state.subheading}</h2>
		`) }

		${ $if((slide.state.button_title !== "" && slide.state.button_url !== ""), () => $html`
		<a href="$${slide.state.button_url}" target="$${slide.state.button_target}" class="button $${slide.state.button_color}">$${slide.state.button_title}</a>
		`) }
	</div>
`;